import { useEffect, useState } from 'react';
import { selectOrderMethod } from '../../../../store/slices/OrderSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useUrlParams from '../../../../hooks/utility/useUrlParams';
import { ORDER_METHODS } from '../../../../services/exports/Constants';
import { useDefaultSlug } from '../selectors/selectors';
import useCompanyBusinessTime from '../../../../hooks/availability/company-business-time/useCompanyBusinessTime';
import useAppMethods from '../../../../hooks/utility/useAppMethods';

interface Props {
  enabled?: boolean;
  orderMethod?: ORDER_METHODS;
  scheduledFor?: string;
}

const useRestaurantClosedFallback = ({ enabled, scheduledFor, orderMethod: checkedOrderMethod }: Props) => {
  const { toggleOrderMethodModal } = useAppMethods();
  const params = useUrlParams();
  const { open_modal } = params;
  const selectedOrderMethod = useSelector(selectOrderMethod);
  const { slug } = useDefaultSlug();
  const orderMethod = checkedOrderMethod ?? selectedOrderMethod;
  const [now] = useState(() => moment());
  const date = scheduledFor ? moment(scheduledFor) : now;
  const { isBusinessTime, isLoading } = useCompanyBusinessTime({
    orderMethod,
  });

  const validate = (): boolean => {
    if (isBusinessTime(date.format())) {
      return true;
    }

    setTimeout(() => toggleOrderMethodModal({ openModal: true }), 0);
  };

  useEffect(() => {
    if (!enabled || open_modal || !slug || isLoading) {
      return;
    }

    validate();
  }, [isLoading, slug]);

  return { validate };
};

export default useRestaurantClosedFallback;
